import { Segment, Table, Header } from 'semantic-ui-react';
import { useCallback } from 'react';
import { useRefreshQuotesStatus, useRequestAllQuotesOptOut, useRefreshOptOutStatus, useRefreshQuotes } from '@app/sdk';

type PayDownPlanQuotesOptOutProps = {
    accountId: string;
  }

export default function PayDownPlanQuotesOptOut(props: PayDownPlanQuotesOptOutProps) {
    const refreshOptOutStatus = useRefreshOptOutStatus();
    const refreshQuotesStatus = useRefreshQuotesStatus();
    const refreshQuotes = useRefreshQuotes();
    
    const { mutate: requestQuoteOptOut, isPending: isEditPending } = useRequestAllQuotesOptOut();

    const quoteOptOut = useCallback(async () => {
        await requestQuoteOptOut({accountId: props.accountId});
        setTimeout(() => {
            refreshOptOutStatus();
            refreshQuotesStatus();
            refreshQuotes();
        }, 2000);
    }, [props.accountId, requestQuoteOptOut]);

    return (
        <>
            <button
                type="button"
                className="ui button blue"
                onClick={() => quoteOptOut()}
                disabled={isEditPending}>
                <span>All Quotes Opt Out</span>
            </button>
        </>
    )
}